import type { UserApp } from 'src/types/user';
import type { Pagination } from 'src/types/common';
import type { UserAppConfig, AppCollaborator } from 'src/types/app';

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export interface AppsState {
  apps: Pagination<UserApp> | null;
  currentApp: UserAppConfig | null;
  collaborators: Pagination<AppCollaborator> | null;
  loading: Record<string, boolean>;
}

const initialAppsState = {
  apps: null,
  currentApp: null,
  collaborators: null,
  loading: {},
};

type Actions = {
  reset: () => void;
};

export const appsModel = create(
  persist<AppsState & Actions>(
    (set) => ({
      ...initialAppsState,
      reset: () => {
        set(initialAppsState);
      },
    }),
    {
      name: 'sc-apps-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
